export enum LayoutVariant {
  FULL,
  WIDE,
  BIG,
  SMALL,
}
